export const NewsletterFieldTypes = {
    PERSONAL_ID: 1,
    FIRST_NAME: 2,
    LAST_NAME: 3,
    EMAIL: 4,
    CELLPHONE: 5
};

export const NewsletterFieldTypeLabels = {
    [NewsletterFieldTypes.PERSONAL_ID]: 'personalId',
    [NewsletterFieldTypes.FIRST_NAME]: 'firstName',
    [NewsletterFieldTypes.LAST_NAME]: 'lastName',
    [NewsletterFieldTypes.EMAIL]: 'email',
    [NewsletterFieldTypes.CELLPHONE]: 'cellphone'
};

export const NewsletterFieldValidationRules = {
    [NewsletterFieldTypes.PERSONAL_ID]: 'id',
    [NewsletterFieldTypes.FIRST_NAME]: 'first_name',
    [NewsletterFieldTypes.LAST_NAME]: 'last_name',
    [NewsletterFieldTypes.EMAIL]: 'email',
    [NewsletterFieldTypes.CELLPHONE]: 'cell'
};

export const NewsletterFieldInputTypes = {
    [NewsletterFieldTypes.PERSONAL_ID]: 'text',
    [NewsletterFieldTypes.FIRST_NAME]: 'text',
    [NewsletterFieldTypes.LAST_NAME]: 'text',
    [NewsletterFieldTypes.EMAIL]: 'email',
    [NewsletterFieldTypes.CELLPHONE]: 'tel'
};
